<!--
 - Author : wanghongling.
 - Date   : 2019/01/17.
 - File   : 水波图组件
 -->
<template>
  <div class="fill" :style="{width: fillWidth, height: fillHeight}">
    <div v-if="showCicrle">
      <div class="fill-bg">
        <img src="../../assets/images/index/gg.png" alt="">
      </div>
      <div class="fill-wq1">
        <img src="../../assets/images/index/wq1.png" alt="">
      </div>
      <div class="fill-wq">
        <img src="../../assets/images/index/wq.png" alt="">
      </div>
    </div>
    <div :id="id" class="liquidCss" :style="{width: liquidList.width, height: liquidList.height}"></div>
  </div>
</template>

<script>
  export default {
    name: 'liquid-fill',
    data () {
      return {
        counter: 1,
        liquid: null
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      showCicrle: {
        type: Boolean,
        default: true
      },
      liquidList: {
        date: 0.5,
        shape: 'path://M367.855,428.202c-3.674-1.385-7.452-1.966-11.146-1.794c0.659-2.922,0.844-5.85,0.58-8.719 c-0.937-10.407-7.663-19.864-18.063-23.834c-10.697-4.043-22.298-1.168-29.902,6.403c3.015,0.026,6.074,0.594,9.035,1.728 c13.626,5.151,20.465,20.379,15.32,34.004c-1.905,5.02-5.177,9.115-9.22,12.05c-6.951,4.992-16.19,6.536-24.777,3.271 c-13.625-5.137-20.471-20.371-15.32-34.004c0.673-1.768,1.523-3.423,2.526-4.992h-0.014c0,0,0,0,0,0.014 c4.386-6.853,8.145-14.279,11.146-22.187c23.294-61.505-7.689-130.278-69.215-153.579c-61.532-23.293-130.279,7.69-153.579,69.202 c-6.371,16.785-8.679,34.097-7.426,50.901c0.026,0.554,0.079,1.121,0.132,1.688c4.973,57.107,41.767,109.148,98.945,130.793 c58.162,22.008,121.303,6.529,162.839-34.465c7.103-6.893,17.826-9.444,27.679-5.719c11.858,4.491,18.565,16.6,16.719,28.643 c4.438-3.126,8.033-7.564,10.117-13.045C389.751,449.992,382.411,433.709,367.855,428.202z',
        bgColor: 'rgba(255,0,0,0.1)',
        colorList: ['rgba(14,197,210,1)', 'rgba(14,197,210,1)', 'rgba(14,197,210,1)'],
        label: false
      }
    },
    computed: {
      fillWidth () {
        let tmpWidth = ''
        if (this.liquidList.width.includes('%')) {
          tmpWidth = parseInt(this.liquidList.width) / 0.7 + '%'
        } else {
          tmpWidth = parseInt(this.liquidList.width) / 0.7 + 'px'
        }
        return tmpWidth
      },
      fillHeight () {
        let tmpHeight = ''
        if (this.liquidList.height.includes('%')) {
          tmpHeight = parseInt(this.liquidList.height) / 0.7 + '%'
        } else {
          tmpHeight = parseInt(this.liquidList.height) / 0.7 + 'px'
        }
        return tmpHeight
      }
    },
    watch: {
      liquidList: {
        handler () {
          this.makeLiquidFill()
        },
        deep: true
      }
    },
    mounted () {
      this.liquidFill()
    },
    destroyed () {
      this.$echarts.dispose(this.liquid)
      this.liquid = null
    },
    methods: {
      /**
       * 初始化echart
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      liquidFill () {
        this.liquid = this.$echarts.init(document.getElementById(this.id))
        this.makeLiquidFill()
      },
      /**
       * echart赋值
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      makeLiquidFill () {
        var tmpNum
        var colorList
        let otherColor = this.liquidList.otherColor | false
        let num = this.liquidList.date
        if (otherColor) {
          colorList = this.liquidList.colorList
          tmpNum = this.liquidList.date
        } else {
          if (num === 0) {
            tmpNum = 0.9
            colorList = ['rgba(59,148,148,0.5)', 'rgba(5,87,95,0.7)', 'rgba(5,118,117,1)']
          } else if (num >= 1 && num <= 6) {
            tmpNum = 0.8
            colorList = ['rgba(219,157,4,0.5)', 'rgba(219,157,4,0.7)', 'rgba(219,157,4,1)']
          } else if (num > 6) {
            tmpNum = 0.7
            colorList = ['rgba(252,54,1,0.5)', 'rgba(252,54,1,0.7)', 'rgba(252,54,1,1)']
          } else {
            tmpNum = 0.62
            colorList = ['rgba(14,197,210,1)', 'rgba(14,197,210,1)', 'rgba(14,197,210,1)']
          }
        }
        let level = this.liquidList.date
        let otherNum = this.liquidList.otherNum || ''
        let otherDate = this.liquidList.otherDate
        this.liquid.setOption({
          title: {
            text: this.liquidList.text,
            textStyle: { // 标题的样式
              color: this.liquidList.titleColor || '#fff', // 字体颜色
              fontFamily: 'Microsoft YaHei', // 字体
              align: 'center', // 文字的水平方式
              verticalAlign: 'middle', // 文字的垂直方式
              fontSize: 12,
              fontWeight: 'normal'
            },
            left: 'center', // 定位
            top: this.liquidList.theTop || '80px'// 文字距离等级的距离
            // backgroundColor: '#03dbdb' // 文字区域的背景颜色
          },
          animationDuration: 3000,
          animationDurationUpdate: 3000,
          series: [{
            type: 'liquidFill', // 类型
            data: [tmpNum, tmpNum - 0.02, tmpNum - 0.1], // 数据是个数组 数组的每一项的值是0-1
            shape: this.liquidList.shape,
            label: {
              normal: {
                formatter: function () {
                  if (otherNum) {
                    return otherNum
                  } else if (otherDate) {
                    return ''
                  } else {
                    if (level === 0) {
                      return '优秀'
                    } else if (level >= 1 && level <= 6) {
                      return '良好'
                    } else if (level > 6) {
                      return '一般'
                    } else {
                      return ''
                    }
                  }
                },
                fontSize: this.liquidList.labelFontSize,
                color: '#fff',
                fontWeight: 'normal'
              }
            },
            outline: {
              borderDistance: 0, // 外部轮廓与图表的距离 数字
              itemStyle: {
                borderWidth: 1, // 边框的宽度
                borderColor: this.liquidList.borderColor // 边框的颜色
              }
            },
            backgroundStyle: {
              color: this.liquidList.bgColor, // 图表的背景颜色
              itemStyle: {
                shadowBlur: 100, // 设置无用
                shadowColor: this.liquidList.borderColor, // 设置无用
                opacity: 1 // 设置无用
              }
            },
            itemStyle: {
              opacity: 1, // 波浪的透明度
              shadowBlur: 4, // 波浪的阴影范围
              shadowColor: this.liquidList.shadowColor // 阴影颜色
            },
            emphasis: {
              itemStyle: {
                opacity: 0.8 // 鼠标经过波浪颜色的透明度
              }
            },
            color: colorList, // 水波的颜色 对应的是data里面值
            center: ['50%', '50%'], // 图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
            radius: this.liquidList.radius, // 图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
            amplitude: 7, // 振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
            waveLength: '60%', // 波的长度 可以是百分比也可以是具体的像素值  百分比下是相对于直径的 取得越大波浪的起伏越小
            phase: 0, // 波的相位弧度 默认情况下是自动
            period: (value, index) => index * 2000,
            direction: 'left', // 波移动的速度 两个参数  left 从右往左 right 从左往右
            waveAnimation: true, // 控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
            animationEasing: 'linear', // 初始动画
            animationEasingUpdate: 'quarticInOut', // 数据更新的动画效果
            animationDuration: 3000, // 初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
            animationDurationUpdate: 300 // 数据更新动画的时长
          }]
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .fill{
    position: relative;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
    &-bg{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
    }
    &-wq{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      backface-visibility: hidden;
      animation: rotate 2s linear infinite;
      transform-style: preserve-3d;
      width: 100%;
      height: 100%;
    }
    &-wq1{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      /*backface-visibility: hidden;*/
      /*animation: rotate1 5s linear infinite;*/
      /*transform-style: preserve-3d;*/
    }
    .liquidCss{
      left: 50%;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
    }
  }
  /*旋转动画*/
  @keyframes rotate {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(360deg);
    }
  }
  /*旋转动画*/
  @keyframes rotate1 {
    from {
      transform: rotateZ(360deg);
    }
    to {
      transform: rotateZ(0deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/echarts/liquidFill.vue